/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import {
  SvgIcon,
  SpanWithData
} from '../'

const DATA_REFETCH_LIMIT = 2

class EmailStatus extends React.PureComponent {
  static propTypes = {
    email: PropTypes.string.isRequired,
    pollInterval: PropTypes.number,  // if specified, the component query will refetch on specified interval
    pollLimitStatusUnchanged: PropTypes.number  // if status doesn't change for a number of times equaling this value, polling will stop
  }

  static defaultProps = {
    pollInterval: 0,  // the query will not poll by default unless props.pollInterval is specified
    pollLimitStatusUnchanged: 4
  }

  constructor(props) {
    super(props)

    this.state = {
      pollCountOnCurrentStatus: 0,
      retriesOnDataFetchError: 0
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.data.error) {
      if (this.state.retriesOnDataFetchError < DATA_REFETCH_LIMIT) {
        this.setState(prevState => ({
          retriesOnDataFetchError: prevState.retriesOnDataFetchError + 1
        }))
      }
    } else if (this.props.data.email) {
      if (nextProps.data.email.status === this.props.data.email.status) {
        this.setState(prevState => ({
          pollCountOnCurrentStatus: prevState.pollCountOnCurrentStatus + 1
        }))
      } else if (this.state.pollCountOnCurrentStatus > 0) {
        this.setState({ pollCountOnCurrentStatus: 0 })
      }
    }
  }

  render() {
    if (this.state.retriesOnDataFetchError === DATA_REFETCH_LIMIT ||
      this.state.pollCountOnCurrentStatus >= this.props.pollLimitStatusUnchanged) {
      this.props.data.stopPolling()
    }

    if (this.props.data.loading || this.props.data.error) {
      return (
        <SvgIcon
          variant='utility'
          symbol='threedots'
          size='x-small'
          colour={this.props.data.loading ? 'light' : 'error'}
        />
      )
    }

    if ([ 'BROKEN', 'BOUNCED', 'BLOCKED', 'SENT_POSTMARK', 'DELIVERED' ].indexOf(this.props.data.email.status) > -1) {
      this.props.data.stopPolling()
    }

    return (
      <SpanWithData forField='EmailStatus' searchKey={this.props.data.email.status} />
    )
  }
}

const getEmail = gql`
  query($id: ID!) {
    email(id: $id) {
      id
      status
    }
  }
`

const withData =
  graphql(getEmail, {
    options: ({ email, pollInterval }) => ({
      variables: {
        id: email
      },
      pollInterval,
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'network-only'
    })
  })

export default withData(EmailStatus)



// WEBPACK FOOTER //
// ./src/components/email-status/index.js